import { render, staticRenderFns } from "./ShipbluCursorPagination.vue?vue&type=template&id=87b26b52"
import script from "./ShipbluCursorPagination.vue?vue&type=script&lang=js"
export * from "./ShipbluCursorPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports